(ns ycweb.app.website.myaccount.orders.common
  (:require
    [ycweb.util.core :as u]))

(defn address-block [details]
  (interpose [:br]
    (map u/nl2br
      (remove (comp nil? u/presence)
        details))))
